module.exports = __webpack_public_path__ + "img/scan-complete.702bcb5c.png";